import LocalStorageMixin from '@virgodev/bazaar/mixins/localstorage';

export default {
  name: 'ChatMixin',
  mixins: [
    LocalStorageMixin,
  ],
  props: {
    user: { type: Object, required: true },
  },
  inject: ['wsEmitter'],
  data() {
    return {
      messages: [],

      chatMembers: [],
      chatRoom: '__default__',
      chatStatus: this.$root.get('chat-status', 'online'),
    };
  },
  computed: {
    serverUser() {
      return this.chatMembers.find(member => member.id === this.user.id);
    },
    serverChatStatus() {
      return this.serverUser ? this.serverUser.status : 'offline';
    },
    serverChatStatus() {
      const me = this.chatMembers.find(member => member.id === this.user.id);
      return me ? me.status : 'offline';
    },
  },
  mounted() {
    this.wsEmitter.on('chat_message', this.onChatMessage);
    this.wsEmitter.on('chat_status', this.onChatStatusUpdated);
    this.wsEmitter.on('join', this.onJoinedRoom);
    this.wsEmitter.on('left', this.onLeftRoom);
    this.wsEmitter.on('login', this.onLogin);

    this.verifyChatStatus();
  },
  unmounted() {
    this.wsEmitter.off('chat_message', this.onChatMessage);
    this.wsEmitter.off('chat_status', this.onChatStatusUpdated);
    this.wsEmitter.off('join', this.onJoinedRoom);
    this.wsEmitter.off('left', this.onLeftRoom);
    this.wsEmitter.off('login', this.onLogin);
  },
  methods: {
    async verifyChatStatus() {
      await this.$root.chatLoggedInPromise;

      if (this.serverChatStatus != this.chatStatus) {
        await this.changeChatStatus(this.chatStatus);
      }
    },

    async onChatMessage(data) {
      // TODO: cut off excessive messages
      if (data.room === this.chatRoom) {
        this.sendChatAck(data.id);
        let messageHandled = false;

        const theMessage = this.messages.find((m) => m.enc_nonce === data.enc_nonce);
        if (theMessage) {
          messageHandled = true;
          theMessage.id = data.id;
          theMessage.sender = data.sender;
          theMessage.timestamp = data.timestamp;
        }

        if (!messageHandled) {
          // this.$root.$emit('chat:before:chat_message', data);
          await this.beforeChatMessage(data);
          this.messages.push(data);
          await this.$nextTick();
          // this.$root.$emit('chat:after:chat_message', data);
          await this.afterChatMessage(data);
        }
      }

      // update status
      const user = this.chatMembers.find(u => u.id === data.sender_id);
      if (user) {
        user.timestamp = new Date().toString();
      }
    },

    // eslint-disable-next-line no-unused-vars
    async onLogin() {
      if (this.status === 'unknown') {
        await this.changeChatStatus('online');
      }
      await this.joinChatRoom(this.chatRoom);
    },

    // eslint-disable-next-line no-unused-vars
    onJoinedRoom(data) {
      // console.warn('joined', data);
      if (data.ok) {
        this.chatMembers = data.members;
      }
    },

    // eslint-disable-next-line no-unused-vars
    onLeftRoom(data) {

    },

    // eslint-disable-next-line no-unused-vars
    onChatStatusUpdated(data) {
      const user = this.chatMembers.find(member => member.id === data.user);
      if (user) {
        user.status = data.status;
        user.timestamp = new Date().toString();
      }
    },

    /** api **/
    async sendOnWebsocket(data, timeout = 10000) {
      return this.$root.sendOnWebsocket(data, timeout);
    },
    async joinChatRoom(room) {
      this.chatRoom = room;
      await this.sendOnWebsocket({ type: 'join', room });
    },
    async leaveChatRoom(room) {
      this.chatRoom = room;
      await this.sendOnWebsocket({ type: 'leave', room });
    },
    async beforeChatMessage(message) {

    },
    async afterChatMessage(message) {

    },
    async sendChatMessage(message, encNonce) {
      if (typeof message === 'string') {
        // This is a new message

        const data = {
          send_status: 'sending',
          id: encNonce,
          type: 'chat_message',
          room: this.chatRoom,
          message,
          upload: null,
          sender_id: this.user.id,
          sender: null,
          msg_type: 'text',
          enc_nonce: encNonce,
          timestamp: null,
        };

        // this.$root.$emit('chat:before:chat_message', data);
        await this.beforeChatMessage(data);
        this.messages.push(data);
        await this.$nextTick();
        // this.$root.$emit('chat:after:chat_message', data);
        await this.afterChatMessage(data);

        return this.api({
          url: 'chat/',
          method: 'POST',
          json: {
            msg_type: 'text',
            message,
            room: this.chatRoom,
            enc_nonce: encNonce,
          }
        });
      }

      // This is a message that failed to send

      const theMessage = this.messages.find((m) => m.id === message.enc_nonce);

      if (theMessage) {
        theMessage.send_status = 'sending';
      }

      return this.api({
        url: 'chat/',
        method: 'POST',
        json: {
          msg_type: 'text',
          message: message.message,
          room: this.chatRoom,
          enc_nonce: message.enc_nonce,
        }
      });
    },
    async sendChatAck(id) {
      return this.$root.markChatRead(id);
    },
    async changeChatStatus(status) {
      const response = await this.sendOnWebsocket({
        type: 'chat_status',
        status,
      });
      if (response.ok) {
        this.chatStatus = response.status;
      }
      return response;
    },
  },
};
